<template>
  <modal
    name="crew-import-row-diff"
    :width="720"
    height="auto"
    :adaptive="true"
    :scrollable="true"
    class="modal-not-overflow"
    @before-open="onBeforeOpen"
    @closed="onClosed"
  >
    <section v-if="row" class="row-diff" aria-labelledby="row-diff-title">
      <app-modal-header
        design="new"
        :eyebrow="`Row ${row.row_number}${row.external_key ? ' · ' + row.external_key : ''}`"
        :title="crewName"
        title-id="row-diff-title"
        @close="close"
      />
      <div class="row-diff__body">
        <p class="row-diff__summary">
          <app-status-badge design="new" compact :tone="action.tone" :label="action.label" />
          <span>{{ changeCountText(row.changes) }}</span>
        </p>
        <import-changes :changes="row.changes" :labels="labels" :limit="1000" full />
        <footer class="row-diff__footer">
          <app-button design="new" theme="dark" @click.native="close">Close</app-button>
        </footer>
      </div>
    </section>
  </modal>
</template>

<script>
import ImportChanges from './ImportChanges'
import { changeCountText, ROW_ACTION } from '../importState'

// The full old -> new list of one diff row. The table only shows how many fields change.
export default {
  name: 'CrewImportRowDiffModal',
  components: { ImportChanges },
  props: {
    labels: { type: Object, default: () => ({}) }
  },
  data() {
    return { row: null, opener: null }
  },
  computed: {
    action() {
      return ROW_ACTION[this.row.action] || { label: this.row.action, tone: 'neutral' }
    },
    crewName() {
      if (this.row.target) return this.row.target.full_name
      const change = key => (this.row.changes[key] ? this.row.changes[key].new : '')
      return [change('first_name'), change('last_name')].filter(Boolean).join(' ') || 'New crew'
    }
  },
  methods: {
    changeCountText,
    onBeforeOpen(event) {
      this.row = event.params.row
      this.opener = document.activeElement
    },
    // The focus goes back to the button that opened the window.
    onClosed() {
      if (this.opener && typeof this.opener.focus === 'function') this.opener.focus()
      this.opener = null
      this.row = null
    },
    close() {
      this.$modal.hide('crew-import-row-diff')
    }
  }
}
</script>

<style lang="scss" scoped>
.row-diff {
  color: $ui-text;
  font-family: $ui-font-body;

  &__body {
    display: flex;
    flex-direction: column;
    gap: $ui-space-16;
    padding: $ui-space-20 $ui-space-24 $ui-space-24;
  }

  &__summary {
    display: flex;
    align-items: center;
    gap: $ui-space-12;
    margin: 0;
    color: $ui-muted;
    font-size: $ui-font-size-body;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }
}

@media (max-width: 600px) {
  .row-diff__body { padding: $ui-space-16; }
}
</style>
